import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { IonButton } from '@ionic/react';
import { ForgottenpwdInstruction, ForgottenpwdContactTrainerWrapper } from 'pages/forgottenpwd/Forgottenpwd.styled';
import useAPIAuth from 'hooks/api/useAPIAuth';
import { Link } from 'react-router-dom';
import { ROUTES } from 'constants/routes';
import styled from 'styled-components';
import { prem } from 'styles/helpers/spacing';

const ResetPwdReminder = styled.div`
  background-color: #fff3cd;
  color: #856404;
  border: 1px solid #ffeaa7;
  border-radius: ${prem(8)};
  padding: ${prem(15)};
  margin: ${prem(20)} 0;
  text-align: center;
  font-size: ${prem(14)};
  font-weight: 500;
`;

interface ForgottenpwdContactTrainerProps {
  email?: string;
  onBack?: () => void;
}

const ForgottenpwdContactTrainer: React.FC<ForgottenpwdContactTrainerProps> = ({
  email,
  onBack,
}) => {
  const { t } = useTranslation('translation');
  const { generatePasswordForTrainer } = useAPIAuth();
  const [isSuccess, setIsSuccess] = useState(false);

  const handleGeneratePassword = async () => {
    if (email) {
      console.log('Generating password for trainer for email:', email);
      const success = await generatePasswordForTrainer(email);
      if (success) {
        setIsSuccess(true);
      }
    }
  };

  return (
    <ForgottenpwdContactTrainerWrapper>
      {!isSuccess ? (
        <>
          <ForgottenpwdInstruction>
            {t('forgottenpwd.trainer.instruction')}
          </ForgottenpwdInstruction>
          <div className="trainer-info">
            <p>{t('forgottenpwd.trainer.info', { email })}</p>
          </div>

          <IonButton
            expand="block"
            fill="solid"
            onClick={handleGeneratePassword}
            className="contact-trainer-button"
          >
            {t('forgottenpwd.trainer.generate.button')}
          </IonButton>

          {onBack && (
            <IonButton
              fill="clear"
              size="small"
              onClick={onBack}
              className="back-button"
            >
              {t('common.back')}
            </IonButton>
          )}
        </>
      ) : (
        <div className="success-message">
          <ForgottenpwdInstruction>
            {t('forgottenpwd.trainer.generate.success')}
          </ForgottenpwdInstruction>
          <div className="trainer-info">
            <p>{t('forgottenpwd.trainer.generate.info', { email })}</p>
          </div>
          <ResetPwdReminder>
            {t('resetpwd.reminder')}
          </ResetPwdReminder>
          <Link to={ROUTES.LOGIN}>{t('common.back')}</Link>
        </div>
      )}
    </ForgottenpwdContactTrainerWrapper>
  );
};

export default ForgottenpwdContactTrainer;